module.exports = __webpack_public_path__ + "static/media/RobotoSlab-Bold.e9751dcc.ttf";